import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleteLog } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmTool } from "@/mixins/index";
export default {
  name: "operationRecordHD",
  mixins: [gmToolNew, gmTool],
  data: function data() {
    return {
      paramsData: {
        gameType: 'hjhd',
        page: 1
      },
      advanced: false,
      dialog: false,
      exportLoading: false,
      total: 0,
      op_type: [{
        label: this.$t('mail'),
        value: 'email'
      }, {
        label: this.$t('announcement'),
        value: 'announce'
      }, {
        label: this.$t('announcementSendOverride'),
        value: 'announce_send'
      }, {
        label: this.$t('server'),
        value: 'server'
      }],
      list: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      this.paramsData.page = e;
      this.paramsData.game_id = this.rawData.game_id;
      this.reqLoading = true;
      deleteLog(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    mereList: function mereList() {
      var _this3 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(resolve, reject) {
          var that, list, page, total, getList, _getList;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _getList = function _getList3() {
                    _getList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(pages) {
                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              page = pages;
                              _context2.next = 3;
                              return deleteLog(_objectSpread(_objectSpread({}, that.paramsData), {}, {
                                page: pages,
                                page_size: 10
                              })).then(function (res) {
                                if (res.status == 200) {
                                  res.data.data.map(function (i) {
                                    i.request = i.params ? i.params.request ? JSON.stringify(i.params.request) : '' : '';
                                    i.response = i.params ? i.params.response ? JSON.stringify(i.params.response) : '' : '';
                                  });
                                  list = [].concat(_toConsumableArray(list), _toConsumableArray(res.data.data));
                                  total = res.data.total;

                                  if (list.length < total) {
                                    getList(page += 1);
                                  } else {
                                    resolve(list);
                                  }
                                }
                              }).finally(function () {
                                that.exportLoading = false;
                              });

                            case 3:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));
                    return _getList.apply(this, arguments);
                  };

                  getList = function _getList2(_x3) {
                    return _getList.apply(this, arguments);
                  };

                  _this3.exportLoading = true;
                  that = _this3;
                  list = [];
                  page = 1;
                  total = 0;
                  getList(page);

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    exportdata: function exportdata() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var list, columns;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.mereList();

              case 2:
                list = _context4.sent;
                columns = [{
                  label: _this4.$t('operator'),
                  prop: 'admin_name'
                }, {
                  label: _this4.$t('game'),
                  prop: 'game'
                }, {
                  label: _this4.$t('operationId'),
                  prop: 'ids'
                }, {
                  label: _this4.$t('request'),
                  prop: 'request'
                }, {
                  label: _this4.$t('response'),
                  prop: 'response'
                }, {
                  label: _this4.$t('operationTime'),
                  prop: 'timestamp'
                }];

                _this4.$export.excel({
                  columns: columns,
                  data: list,
                  title: _this4.$route.meta.title
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};